import GoogleAnalyticsApi from './GoogleAnalyticsApiContainer';

export default GoogleAnalyticsApi;



// WEBPACK FOOTER //
// ./src/components/GoogleAnalyticsApi/index.js